import { createContext, useContext } from "react";

export const RootContext = createContext({
  imageBaseUrl: "",
});

export const useRootContext = () => useContext(RootContext);
